import { Fragment } from 'react';
import styled from 'styled-components';

import { Button, Icon, Table, Tooltip } from 'components/common';
import { colours } from 'utils/theme';

const StyledTable = styled(Table)`
  margin-top: 10px;
`;

const StatusTag = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
  background-color: ${p => (p.$active ? '#e6f7e6' : '#f5f5f5')};
  color: ${p => (p.$active ? '#137333' : '#666')};
`;

const tablePerPage = [
  { value: 10, label: '10 per page' },
  { value: 25, label: '25 per page' },
  { value: 50, label: '50 per page' },
];

const ProductTable = ({
  data,
  onEdit,
  onToggleActive,
  onMove,
  canMoveUp,
  canMoveDown,
}) => {
  const config = {
    headers: [
      { label: 'Name', key: 'name', minWidth: 160, maxContentWidth: 240 },
      {
        label: 'Description',
        key: 'description',
        minWidth: 200,
        maxContentWidth: 360,
      },
      {
        label: 'Order',
        key: 'sortOrder',
        minWidth: 60,
        maxContentWidth: 60,
      },
      {
        label: 'Status',
        key: 'isActive',
        minWidth: 80,
        maxContentWidth: 80,
      },
      {
        label: 'Actions',
        key: 'actions',
        minWidth: 220,
        maxContentWidth: 260,
      },
    ],
    createRow: (r, i) => (
      <Fragment key={`product-${r.id}-${i}`}>
        <div>{r.name}</div>
        <Tooltip title={r.description}>
          <div
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {r.description}
          </div>
        </Tooltip>
        <div>{r.sortOrder}</div>
        <div>
          <StatusTag $active={r.isActive}>
            {r.isActive ? 'Active' : 'Inactive'}
          </StatusTag>
        </div>
        <div
          style={{
            display: 'flex',
            gap: 6,
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
          }}
        >
          <Tooltip title='Move up'>
            <Button
              size='small'
              onClick={() => onMove(r.id, 'up')}
              disabled={!canMoveUp(r)}
              data-testid={`product-${r.id}-move-up`}
            >
              <Icon icon='chevronUp' size='sm' color={colours.darkGrey} />
            </Button>
          </Tooltip>
          <Tooltip title='Move down'>
            <Button
              size='small'
              onClick={() => onMove(r.id, 'down')}
              disabled={!canMoveDown(r)}
              data-testid={`product-${r.id}-move-down`}
            >
              <Icon icon='chevronDown' size='sm' color={colours.darkGrey} />
            </Button>
          </Tooltip>
          <Button
            size='small'
            onClick={() => onEdit(r)}
            data-testid={`product-${r.id}-edit`}
          >
            Edit
          </Button>
          <Button
            size='small'
            onClick={() => onToggleActive(r)}
            data-testid={`product-${r.id}-toggle`}
          >
            {r.isActive ? 'Deactivate' : 'Reactivate'}
          </Button>
        </div>
      </Fragment>
    ),
  };

  return (
    <StyledTable
      data={data}
      config={config}
      pageSizeOptions={tablePerPage}
      sortable
      paginate
    />
  );
};

export default ProductTable;
